import type { ChangeEvent, FormEvent } from 'react';
import { Search } from 'lucide-react';
import { filterFieldLabelClass, toolbarSearchInputClass } from '@/shared/ui/fleet-system/filters';
import { secondaryButtonClass, toolbarControlClass } from '@/shared/ui/formClasses';
import type { RoleOption } from '../model/roles';
import type { UserFilters } from '../model/users';
import RoleOptions from './RoleOptions';

type UsersFiltersProps = {
  value: UserFilters;
  roleOptions: RoleOption[];
  onChange: (value: UserFilters) => void;
  onApply: () => void;
};

/** Ricerca, ruolo e stato; la lista cambia solo con Applica filtri (o Invio). */
export default function UsersFilters({ value, roleOptions, onChange, onApply }: UsersFiltersProps) {
  const update =
    (key: keyof UserFilters) => (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
      onChange({ ...value, [key]: e.target.value });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onApply();
  };

  return (
    <form
      role="search"
      aria-label="Filtri utenti"
      onSubmit={handleSubmit}
      className="flex flex-wrap items-end gap-2 rounded-xl border border-default bg-default p-4 shadow-resting"
    >
      <label className="min-w-[220px] max-w-xl flex-1">
        <span className={filterFieldLabelClass}>Ricerca</span>
        <span className="relative mt-1 block">
          <Search
            aria-hidden
            className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-placeholder"
          />
          <input
            type="search"
            placeholder="Nome o email…"
            value={value.search}
            onChange={update('search')}
            className={toolbarSearchInputClass('pl-8')}
          />
        </span>
      </label>
      <label className="w-44">
        <span className={filterFieldLabelClass}>Ruolo</span>
        <select
          value={value.role}
          onChange={update('role')}
          className={`${toolbarControlClass} mt-1`}
        >
          <option value="">Tutti i ruoli</option>
          <RoleOptions options={roleOptions} />
        </select>
      </label>
      <label className="w-40">
        <span className={filterFieldLabelClass}>Stato</span>
        <select
          value={value.status}
          onChange={update('status')}
          className={`${toolbarControlClass} mt-1`}
        >
          <option value="">Tutti gli stati</option>
          <option value="active">Attivi</option>
          <option value="inactive">Disattivi</option>
        </select>
      </label>
      <button type="submit" className={secondaryButtonClass}>
        Applica filtri
      </button>
    </form>
  );
}
